import type { AuthState } from "@/auth/auth.types";

export type AudienceMinerPermission = "view" | "manage" | "export" | "admin";

const featureEnabled = (): boolean => process.env.REACT_APP_AUDIENCE_MINER_ENABLED === "true";

const permissions = (state: AuthState): Set<AudienceMinerPermission> =>
    state.status === "authenticated" ? new Set<AudienceMinerPermission>(["view", "manage", "export", "admin"]) : new Set<AudienceMinerPermission>();

const can = (state: AuthState, permission: AudienceMinerPermission): boolean =>
    featureEnabled() && permissions(state).has(permission);

const availableWorkspaces = (state: AuthState): string[] => {
    if (state.status !== "authenticated") return [];
    const configuredDefault = process.env.REACT_APP_AUDIENCE_MINER_DEFAULT_WORKSPACE?.trim();
    const defaultWorkspace = configuredDefault !== undefined && configuredDefault !== "" && configuredDefault !== "*"
        ? configuredDefault : "enviaDinero";
    const configured = (process.env.REACT_APP_AUDIENCE_MINER_ENABLED_WORKSPACES ?? defaultWorkspace)
        .split(",").map((value) => value.trim()).filter((value) => value !== "");
    return configured.includes("*") ? [defaultWorkspace] : Array.from(new Set(configured));
};

export const audienceMinerAccess = { featureEnabled, permissions, can, availableWorkspaces };
